import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'

import { IonicModule } from '@ionic/angular'

import { ModalConfirmPage } from './modal-confirm.page'
import { ModuleSharedModule } from '../../../../shared/modules/module-shared.module';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModuleSharedModule
  ],
  declarations: [ModalConfirmPage]
})
export class ModalConfirmPageModule { }
